import { Box, Button } from '@chakra-ui/react'
import { CSVLink } from 'react-csv'
import { diagnosisTitles } from '../../../types/FirestoreUser'
import { ProgressionQueryHit } from '../../../types/ProgressionQuery'

interface Props {
  hits: ProgressionQueryHit[]
}

export default function QueryResultsExport({ hits }: Props) {
  return (
    <Box>
      <Button variant='link'>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore - react-csv types incompatible with React 18 */}
        <CSVLink
          data={hits.map((hit) => {
            const {
              patientId,
              netChange,
              averagePerMonth,
              firstScoreMonth,
              lastScoreMonth,
              diagnosis,
              diagnosisDate,
              firstName,
              lastName,
              uid,
            } = hit
            return {
              'Patient ID': patientId,
              'First Name': firstName,
              'Last Name': lastName,
              'Net Change': netChange,
              'Average per Month': averagePerMonth.toFixed(2),
              'First Score Month': firstScoreMonth,
              'Last Score Month': lastScoreMonth,
              Diagnosis: diagnosisTitles[diagnosis],
              'Diagnosis Date': diagnosisDate,
              UID: uid,
            }
          })}
          filename={`als-registry-query-${new Date().toISOString()}.csv`}
        >
          Download Table as CSV
        </CSVLink>
      </Button>
    </Box>
  )
}
